<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="contents" epub:type="toc" role="doc-toc">
<header><h1 class="h2" id="contents"><span aria-label=" Page xiv. " epub:type="pagebreak" id="page_xiv" role="doc-pagebreak">C<span class="small">ONTENTS</span></span></h1></header>
<p class="toca"><a href="#/xhtml/intro">Introduction</a></p>
<p class="toct"><a href="#/xhtml/part01"><b>Part One: Who Am I?</b></a></p>
<p class="toc"><a href="#/xhtml/ch01">1. The Nameless Uncarved Wood</a></p>
<p class="toc"><a href="#/xhtml/ch02">2. The Original AI: Animate Intelligence</a></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample">3. The Most Important Relationship in Your Life</span></p>
<p class="toct"><span href="#/xhtml/part02" title="Link target outside of Sample"><b>Part Two: Where Am I?</b></span></p>
<p class="toc"><span href="#/xhtml/ch04" title="Link target outside of Sample">4. The Patterns of the Universe</span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample">5. The Harmonic Dance of Life</span></p>
<p class="toct"><span href="#/xhtml/part03" title="Link target outside of Sample"><b>Part Three: What Am I?</b></span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample">6. The Deep Purpose of Life</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample">7. The Tao in My Own Nature</span></p>
<p class="toct"><span href="#/xhtml/part04" title="Link target outside of Sample"><b>Part Four: How Should I Live?</b></span></p>
<p class="toc"><span href="#/xhtml/ch08" title="Link target outside of Sample">8. Flourishing as an Integrated Organism</span></p>
<p class="toc"><span href="#/xhtml/ch09" title="Link target outside of Sample">9. Cultivating Integrated Values</span></p>
<p class="toc"><span href="#/xhtml/ch10" title="Link target outside of Sample">10. Human/Nature</span></p>
<p class="toct"><span href="#/xhtml/part05" title="Link target outside of Sample"><b>Part Five: Why Am I?</b></span></p>
<p class="toc"><span href="#/xhtml/ch11" title="Link target outside of Sample">11. Everything Is Connected</span></p>
<p class="toc"><span href="#/xhtml/ch12" title="Link target outside of Sample">12. From Fixed Self to Infinite Li: The Fractal Nature of Identity</span></p>
<p class="toct"><span href="#/xhtml/part06" title="Link target outside of Sample"><b>Part Six: Where Are We Going?</b></span></p>
<p class="toc"><span href="#/xhtml/ch13" title="Link target outside of Sample">13. Weaving a New Story of Meaning</span></p>
<p class="toct"><span href="#/xhtml/glossary" title="Link target outside of Sample"><i>Glossary</i></span><span aria-label=" Page xv. " epub:type="pagebreak" id="page_xv" role="doc-pagebreak"></span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample"><i>Further Reading</i></span></p>
<p class="toc"><span href="#/xhtml/ack" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="toc"><span href="#/xhtml/notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/xhtml/bm03" title="Link target outside of Sample"><i>Permissions</i></span></p>
<p class="toc"><span href="#/xhtml/bm04" title="Link target outside of Sample"><i>Illustrations</i></span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample"><i>Index</i></span></p>
<p class="toc"><span href="#/xhtml/author" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="toc"><span href="#/xhtml/bm05" title="Link target outside of Sample"><i>About New Society Publishers</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2ab3fea4